export default "__VITE_ASSET__DNVBMVSk__"